import { UserRole } from '@snap-types/models/enums';

import type { RoutesConfig } from './types';

export const routesConfig = {
  root: {
    label: 'Home',
    path: '/',
  },

  // Quotes
  quoteQueue: {
    label: 'Quote Queue',
    path: '/teams/:teamCode/quotes',
  },
  quoteView: {
    label: 'View Quote',
    path: '/teams/:teamCode/quotes/:id/view',
  },

  // AutoConfigurator
  snapQuoteAutoConfiguratorUI: {
    label: 'AutoConfigurator UI',
    path: '/teams/:teamCode/snap-quotes/:id/alpha/:alphaQuoteUuid',
  },

  // Snap Quotes
  duplicateExistingQuote: {
    label: 'New SNAP Quote',
    path: '/teams/:teamCode/snap-quotes/:id/duplicate-quote',
  },
  snapQuoteEdit: {
    label: 'Edit Quote',
    path: '/teams/:teamCode/snap-quotes/:id',
  },
  snapQuoteNew: {
    label: 'New SNAP Quote',
    path: '/teams/:teamCode/snap-quotes/new',
  },
  snapQuoteView: {
    label: 'View Quote',
    path: '/teams/:teamCode/snap-quotes/:id/view',
  },

  // Search
  partSearch: {
    label: 'Part Search',
    path: '/teams/:teamCode/parts',
  },

  // Metrics
  metrics: {
    label: 'Metrics',
    path: '/metrics',
  },

  // Admin
  admin: {
    label: 'Admin',
    path: '/admin',
    minimumRole: UserRole.SITE_ADMIN,
  },
  adminUsers: {
    label: 'Users',
    path: '/admin/users',
    minimumRole: UserRole.SUPERADMIN,
  },
  adminSites: {
    label: 'Sites',
    path: '/admin/sites',
    minimumRole: UserRole.SITE_ADMIN,
  },
  adminSnapSiteConfig: {
    label: 'Snap Site Config',
    path: '/admin/sites/:siteCode/snap-config/:snapSiteConfigUuid',
    minimumRole: UserRole.SITE_ADMIN,
  },

  // User
  userProfile: {
    label: 'User Profile',
    path: '/current-user',
  },
} as const satisfies RoutesConfig;
